<template>
  <nav>
    <v-toolbar color="primary" dark app extended extension-height="1" class="noPOPrint">
      <v-toolbar-side-icon @click="drawer = !drawer" class="white--text"></v-toolbar-side-icon>
      <v-toolbar-title class="text-uppercase white--text" v-if="!inf">
        <span class="font-weight-light">ashyaat</span>
        <span>CRM</span>
      </v-toolbar-title>
      <v-toolbar-title class="text-uppercase white--text" v-if="inf">
        <span class="font-weight-light">{{infsite.sitename}}</span>
        <span>CRM</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
        <v-text-field
          label="Search by Phone Number, Key, Doc ID.."
          solo
          dark
          v-if="false && !inf && (userRole == 'admin' || superAdmin)"
          hide-details
          clearable
          @click:append="getLeadsBySearch()"
          @keyup.enter="getLeadsBySearch()"
          append-icon="search"
          :loading="searchLoading"
          v-model="searchPhoneNumber"
        >
        </v-text-field>
      <v-spacer></v-spacer>
      <v-chip  v-if="imports ? imports.importing:false"  color="secondary" text-color="white">
        <v-btn fab flat small :loading="imports?imports.importing:false" dark></v-btn>
        {{ imports.type ? imports.type.toUpperCase() : ''  }} / {{ imports.count }}
        <v-btn v-if="superAdmin" fab icon color="primary" small dark>
          <v-icon>sync_disabled</v-icon>
        </v-btn>
      </v-chip>
      <v-chip  color="secondary" text-color="white">
        <v-avatar v-if="userImage">
          <img :src="userImage" :alt="userName">
        </v-avatar>
        {{ userName }}
      </v-chip>
      
      <!-- dropdown menu -->
      <v-menu offset-y>
        <v-btn slot="activator" icon>
          <v-icon color="white">apps</v-icon>
        </v-btn>
          
        <v-list>
          <v-btn @click="logout" flat color="grey">
            <span>Sign Out</span>
            <v-icon right>exit_to_app</v-icon>
          </v-btn>
        </v-list>
      </v-menu>
      <v-avatar size="12px" color="white">
        <v-avatar size="10px" :color="connection">
        </v-avatar>
      </v-avatar>
      <v-progress-linear v-if="progress" slot="extension" color="white" height="3" :indeterminate="true" class="ma-0"></v-progress-linear>  
      <v-progress-linear v-if="scroll" slot="extension" color="white" height="5" v-model="scrollAmount" class="ma-0"></v-progress-linear>
    </v-toolbar>
    


    <v-navigation-drawer 
      app 
      v-model="drawer"
      class="primary"
      floating
      temporary
      >
      <v-layout column align-center>
        <v-flex class="mt-5 text-xs-center">
          <v-avatar v-if="userImage" size="100">
            <img class="text-xs-center" :src="userImage">
          </v-avatar>
          <div></div>
          <div></div>
          <p class="white--text subheading mt-1 text-lg-center">{{ userName }}</p>
        </v-flex>
        <v-flex class="mt-4 mb-3">
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12>
          <v-list dense dark>
            <template v-for="item in items">
              <v-layout
                row
                v-if="item.heading"
                align-center
                :key="item.heading"
              >
                <v-flex xs6>
                  <v-subheader v-if="item.heading">
                    {{ item.heading }}
                  </v-subheader>
                </v-flex>
                <v-flex xs6 class="text-xs-center">
                  <a href="#!" class="body-2 black--text">EDIT</a>
                </v-flex>
              </v-layout>
              <v-list-group
                v-else-if="item.children"
                v-model="item.model"
                :key="item.text"
                :prepend-icon="item.model ? item.icon : item['icon-alt']"
                append-icon=""
              >
                <v-list-tile slot="activator">
                  <v-list-tile-content>
                    <v-list-tile-title>
                      {{ item.text }}
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile
                  v-for="(child, i) in item.children"
                  :key="i"
                  @click="goTo(child.path)"
                >
                  <v-list-tile-action v-if="child.icon">
                    <v-icon>{{ child.icon }}</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title  >
                      {{ child.text }}
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list-group>
              <v-list-tile v-else @click="goTo(item.path)" :key="item.text">
                <v-list-tile-action>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ item.text }}
                  </v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>
          </v-list>
        </v-flex>
      </v-layout>
    </v-navigation-drawer>
    <crm 
      v-if="false && !inf && (userRole == 'admin' || superAdmin)"
      :embed="embed" 
      :userName="userName"
      :userRole="userRole"
      :beta="beta"
      :editLeadEmbed="selectedLead"
      :dialogSearch="dialogSearch"
      :superAdmin="superAdmin"
      :userData="userData"
      @resetEmbed="resetEmbed"
    />
  </nav>
  
</template>

<script>
import Popup from './Popup'
import {firebase, auth, db, store} from '@/fb';
import crm from '@/views/crm';



export default {
  components: { Popup, crm },
  data() {
    return {
      drawer: false,
      imports:null,
      snackbar: false,
      searchPhoneNumber:null,
      searchLoading: false,
      leads:[],
      embed:true,
      dialogSearch:false,
      selectedLead:null,
    }
  },
  methods: {
    resetEmbed(){
      this.dialogSearch=false
      this.selectedLead=false
    },
    async getLeadsBySearch() {
      this.searchLoading = true
      this.visibleLeads = []
      this.filteredLeads = []
      this.leads = []
      let search = this.searchPhoneNumber
      console.log(search);
      if(!search || search == '') {
        this.loading = false
        return true
      }
      search = search.trim()
      let leads1 = await store.collection('leads')
      .where('phone_number_1', '==', search)
      .get()
      .then(x=>x.docs.map(y=>{return {...y.data(), key:y.id}}));
      let leads2 = await store.collection('leads')
      .where('phone_number_2', '==', search)
      .get()
      .then(x=>x.docs.map(y=>{return {...y.data(), key:y.id}}));
      let leads3 = await store.collection('leads')
      .where('phone_number_3', '==', search)
      .get()
      .then(x=>x.docs.map(y=>{return {...y.data(), key:y.id}}));
      let leads4 = await store.collection('leads')
      .where('document_number', '==', search)
      .get()
      .then(x=>x.docs.map(y=>{return {...y.data(), key:y.id}}));
      let leads5 = await store.collection('leads').doc(search).get().then(x=>x.data())
      let leads = [...leads1, ...leads2, ...leads3, ...leads4, leads5].filter(x=>x)
      console.log('search store', leads)
      this.leads = leads
      this.selectedLead = this.leads
      this.dialogSearch = true
      this.searchLoading = false
    },
    logout: function() {
      auth.signOut();
      this.$store.state.centerData = null
      this.$store.state.role = null
      this.$store.state.tokens = null
      this.$store.state.user = null
      this.$store.state.candidates = null
      this.$store.state.userData = null
    },
    importActive(){
      db.ref('imports')
      .on('value', snap=>{
        this.imports = snap.val()
        console.log('imports', this.imports)
      })
    },
    goTo(path) {
      this.$router.push(path)
    },
    async loadScrollStyle(theme){
      let b = `
        ::-webkit-scrollbar-track {
          -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.22);
            background-color: ${theme.secondary};
        }

        ::-webkit-scrollbar {
          width: 5px;
          background-color: ${theme.primary};
        }

        ::-webkit-scrollbar-thumb {
          background-color: ${theme.primary};
          border-radius:  0 0 20px 20px; 
        }`
        let a = document.createElement('style')
        a.innerHTML = b
        document.head.append(a)
    },
  },
  props: {
    connection: {
      required: true,
      default: 'error'
    },
    userName: {
      required: true,
      default: 'ASHYAA'
    },
    userImage: {
      required: true,
      default: ''
    },
    progress:{
      default: false
    },
    scroll:{
      default: false
    },
    superAdmin:{
      default: false
    },
    scrollAmount: {
      default: 0
    },
    userRole:{
      default: false
    },
    beta:{
      default: false
    },
    userData:{
      default: false
    },
  },
  watch:{infLoad(){}},
  computed:{
    infLoad() {
      if(this.$store.state.user && this.$store.state.user.favicon) {
        var link = document.querySelector("link[rel~='icon']");
        if (!link) {
            link = document.createElement('link');
            link.rel = 'icon';
            document.getElementsByTagName('head')[0].appendChild(link);
        }
        link.href = this.$store.state.user.favicon;
      }
      if(this.$store.state.user && this.$store.state.user.sitename) {
        document.title = this.$store.state.user.sitename.toUpperCase() + ' | CRM'
      }
      if(this.$store.state.user && this.$store.state.user.primary){
        this.$vuetify.theme.primary = this.$store.state.user.primary
        this.loadScrollStyle({
          primary: this.$store.state.user.primary,
          secondary: this.$store.state.user.secondary
        })
      }
      if(this.$store.state.user && this.$store.state.user.secondary){
        this.$vuetify.theme.secondary = this.$store.state.user.secondary
      }
    },
    items() {
      let role =  this.$store.state.role
      return this.$store.state.menu[role]
    },
    inf(){
      return this.$store.state.inf
    },
    infsite(){
      return this.$store.state.user
    },
  },
  created () {
    this.importActive()
  }
}
</script>

<style>
.v-toolbar__extension {
    padding: 0 !important;
}
</style>
